<template>
    <PopupRouterView :showLeftIcon="true" label="Bill Of Process Part Type Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="billofprocessparttype"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="billOfProcessPartTypeInput">


        <b-card header="Bill Of Process Part Type" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BillOfProcessPartType from '@/models/BillOfProcessPartType/BillOfProcessPartType';
import BillOfProcessPartTypeList from '@/models/BillOfProcessPartType/BillOfProcessPartTypeList';
import BillOfProcessPartTypeFilter from '@/filters/BillOfProcessPartType/BillOfProcessPartTypeFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterBillOfProcessPartType : null,
			currentBillOfProcessPartTypePage : 1,
			billOfProcessPartTypePageSize: 10,
			sortByBillOfProcessPartType: '',
			sortDescBillOfProcessPartType: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getBillOfProcessPartType : async function(id) {
			this.isBusy = true;
			BillOfProcessPartType.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadBillOfProcessPartType = true;
			this.filterBillOfProcessPartType.id = this.modelId;
			BillOfProcessPartType.downloadDataDetail(this, this.filterBillOfProcessPartType).then(result => {
				this.isDownloadBillOfProcessPartType = false;
			}).catch(error => { this.isDownloadBillOfProcessPartType = false; })
		},
		getBillOfProcessPartTypes : async function(input) {
			let filter = new BillOfProcessPartTypeFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isBillOfProcessPartTypeComboLoading = true;
			BillOfProcessPartType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcessPartTypes = result.data
				}
				this.isBillOfProcessPartTypeComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.billOfProcessPartTypeInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						BillOfProcessPartType.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'billofprocessparttypeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						BillOfProcessPartType.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'billofprocessparttypeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfProcessPartType.updateData(this, model, id)
					.catch((error) => {
						this.getBillOfProcessPartType(id);
					});
				}
			});
		},
		onHidden() {
			this.getBillOfProcessPartTypes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterBillOfProcessPartType = new BillOfProcessPartTypeFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getBillOfProcessPartType(id);
			} else {
				this.modelId = id;
				this.getBillOfProcessPartType(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
}
</script>
